// Constants
import {REDUX_SET} from './constants';

export const show = () => ({type: REDUX_SET, data: {visible: true}});

export const hide = () => ({type: REDUX_SET, data: {visible: false}});
